import { Stack } from "@mui/joy";
import { type MRT_TableInstance } from "material-react-table";
import { memo, useCallback } from "react";
import { EntitiesSearch, ExportAsCsvButton } from "components/base";
import { UsersAddButton } from "components/entities";
import { type UserForColumnDef } from "./models";

interface UsersListToolbarProps {
  onSearchChange: (value: string) => void;
  searchValue: string;
  isDecentriqAdmin: boolean;
  table: MRT_TableInstance<UserForColumnDef>;
  isUsersPage: boolean;
  isSuperAdminReadOnly: boolean;
  hasData: boolean;
}

const getHeaders = () => ["Email", "Role", "Organization", "Created At"];

const UsersListToolbar = memo<UsersListToolbarProps>(
  ({
    onSearchChange,
    searchValue,
    isDecentriqAdmin,
    table,
    isUsersPage,
    isSuperAdminReadOnly,
    hasData,
  }) => {
    const getRows = useCallback(() => {
      return table.getPaginationRowModel().rows.map((row) => {
        const { email, userRole, organizationName, createdAt } = row.original;
        const formattedDate = new Date(createdAt).toLocaleString();
        return [email, userRole, organizationName, formattedDate];
      });
    }, [table]);
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        spacing={2}
        width="100%"
      >
        <Stack sx={{ minWidth: "280px" }}>
          <EntitiesSearch
            onChange={(event) => onSearchChange(event.target.value)}
            onClear={() => onSearchChange("")}
            placeholder="Search users"
            value={searchValue}
          />
        </Stack>
        {isDecentriqAdmin && hasData ? (
          <ExportAsCsvButton
            fileName="users.csv"
            getHeaders={getHeaders}
            getRows={getRows}
          />
        ) : null}
        {!isUsersPage && !isSuperAdminReadOnly && <UsersAddButton />}
      </Stack>
    );
  }
);

UsersListToolbar.displayName = "UsersListToolbar";

export default UsersListToolbar;
